import React from 'react';

let Priority = (props) => {
  let {setPriority} = props;
  return (
    <div className="priorityVis">
      <h3>Prioridad</h3>
      <div id="priorities">
        <div className="priority white" onClick={() => setPriority(0)}></div>
        <div className="priority green" onClick={() => setPriority(1)}></div>
        <div className="priority yellow" onClick={() => setPriority(2)}></div>
        <div className="priority red" onClick={() => setPriority(3)}></div>
      </div>
    </div>
  )
}

export default Priority;


// WEBPACK FOOTER //
// ./src/Components/AddCards/Priority.js